module.exports = __webpack_public_path__ + "img/banner_ms_case1.252ccfbe.png";